import { Typography, TypographyProps } from '@branch-messenger/willow-ui'
import { FC, ReactNode } from 'react'

export type AccountDetailSubtitleProps = TypographyProps & {
  children: ReactNode
}

export const AccountDetailSubtitle: FC<AccountDetailSubtitleProps> = ({
  children,
  ...restProps
}) => {
  return (
    <Typography
      $color="textMuted"
      style={{
        wordBreak: 'break-all',
      }}
      {...restProps}
    >
      {children}
    </Typography>
  )
}
